var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerformIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.68 27.3999C24.8 27.3999 21.66 32.6799 21.66 32.6799C21.66 32.6799 24.79 37.9599 32.68 37.9599C40.57 37.9599 43.7 32.6799 43.7 32.6799C43.7 32.6799 40.56 27.3999 32.68 27.3999ZM32.68 36.8199C30.39 36.8199 28.54 34.9599 28.54 32.6799C28.54 30.3899 30.4 28.5399 32.68 28.5399C34.97 28.5399 36.82 30.3999 36.82 32.6799C36.82 34.9699 34.97 36.8199 32.68 36.8199Z",
    fill: "#C92626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.68 65.36C14.66 65.36 0 50.7 0 32.68C0 14.66 14.66 0 32.68 0C50.7 0 65.36 14.66 65.36 32.68C65.36 50.7 50.7 65.36 32.68 65.36ZM32.68 3C16.31 3 3 16.31 3 32.68C3 49.05 16.31 62.36 32.68 62.36C49.05 62.36 62.36 49.05 62.36 32.68C62.36 16.31 49.04 3 32.68 3Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.68 53.63C21.13 53.63 11.73 44.23 11.73 32.68C11.73 21.13 21.13 11.73 32.68 11.73C44.23 11.73 53.63 21.13 53.63 32.68C53.63 44.23 44.23 53.63 32.68 53.63ZM32.68 14.73C22.78 14.73 14.73 22.78 14.73 32.68C14.73 42.58 22.78 50.63 32.68 50.63C42.58 50.63 50.63 42.58 50.63 32.68C50.63 22.78 42.58 14.73 32.68 14.73Z",
    fill: "#F2F2F2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65.36,
    height: 65.36,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65.36,
    height: 65.36,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformIcon);
export default __webpack_public_path__ + "static/media/perform-icon.5f360ea2afce42ff23ac5b50c02ab013.svg";
export { ForwardRef as ReactComponent };